export default __webpack_public_path__ + "static/media/jira.eb0dc3d2.svg";